<template>
  <div class="index-container">
    <!-- <Header :showBack="false" :nosearch="false" :height="50" :title="`大盘指数`"/> -->
    <ComHeader type="4" :title="'大盘指数'" />
    <div class="tab-wrap">
      <Tabs :list="tabList" @index-click="tabClick" />
      <div class="tab-content">
        <Hs v-if="tabActive === 0" />
        <Bk v-if="tabActive === 1" />
        <Qq v-if="tabActive === 2" />
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import Header from '@/components/header.vue'
import Tabs from './tabs'
import Hs from './tabs/hs'
import Bk from './tabs/bk'
import Qq from './tabs/qq'

import ComHeader from "@/components/common/comHeader.vue";

export default {
  name: "index",
  components: { ComHeader, Tabs, Hs, Bk, Qq},
  data () {
    return {
      tabActive: 0,
      tabList: [
        {
          title: '沪深'
        },
        {
          title: '板块'
        },
        {
          title: '全球'
        }
      ]
    }
  },
  methods: {
    tabClick(index) {
      this.tabActive = index
    }
  }
}
</script>

<style lang="stylus" scoped>
div
  box-sizing border-box
.index-container
  background #fff
  width 100%
  height 100vh
  color #333333
</style>
